import { getRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createChat: (body) => postRequest('/chats', body),
    getChat: (chatId, params = {}) => getRequest(`/chats/${chatId}`, { params }),
    getAssignmentChatSummary: async (filter, options = {}) => {
        const chats = await services.listChats(filter, options);
        return chats?.[0] || null;
    },
    getAssignmentChatStats: async (filter) => {
        const chats = await services.listChats(filter, {
            includeMessages: false,
            includeStats: true,
        });
        return chats?.[0]?.stats?.user_message_count_by_draft || null;
    },
    getSuggestions: (body) => postRequest('/chat/suggestions', body),
    listChats: (filter, options = {}) =>
        getRequest('/chats', {
            params: {
                $filter: JSON.stringify(filter),
                ...(options.includeMessages === false ? { include_messages: 'false' } : {}),
                ...(options.includeStats ? { include_stats: 'true' } : {}),
            },
        }),
    markRead: (body) => postRequest('/chat/read', body),
    pushMessage: (body) => postRequest('/chat/push-message', body),
    updateChat: (chatId, body) => patchRequest(`/chats/${chatId}`, body),
};

export default services;
